import { Line } from './line';
export class RefToRefLine extends Line {
    ref1_;
    ref2_;
    color;
    constructor(ref1, ref2, color) {
        super();
        this.ref1_ = ref1;
        this.ref2_ = ref2;
        this.validateColor(color);
        this.color_ = color;
        this.updateVertBuf([this.ref1_, this.ref2_]);
    }
    update() {
        // Do nothing
    }
}
